import '../../css/header.css';
import React, { useState, useEffect } from "react";
import DropdownMenu from '../ui/DropdownMenu';
import { useNavigate, Link } from 'react-router-dom';
import DropdownNotifications from '../ui/DropdownNotifications';
import { Mailbox, PanelLeft } from "lucide-react"; // Import the Mailbox icon from Lucide
import CheckOutCart from '../ui/CheckOutCart';
import MessageSlideUp from '../messaging/MessageSlideUp';
import { useAuth } from "../../context/AuthContext";
import { fetchContactFormUnreadCount } from '../../services/messagingService';
import { useMessaging } from '../../context/MessagingContext';
import ServSpaceLogo from '../../themes/ServSpaceLogo'
import SettingsModal from '../settings/SettingsModal';
import { useTheme } from '../../context/ThemeContext'
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { deleteAccount } from '../../services/authService';

const Header = ({ toggleNav, hidden }) => {
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [cartOpen, setCartOpen] = useState(false);
    const [messagesOpen, setMessagesOpen] = useState(false);
    const [isSettingsOpen, setIsSettingsOpen] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(null); // Track which dropdown is open
    // const [isDropdownClosed, setIsDropdownClosed] = useState(false); // Track if dropdown is closed
    const navigate = useNavigate();
    const { accessToken, role, logout } = useAuth();

    const profile = useSelector((state) => state.profile.data);


    const { isDarkMode, toggleTheme } = useTheme();


    const { unreadCount, setUnreadCount } = useMessaging();

    const goHome = () => navigate("/home");

    const handleDropdownToggle = (dropdownName) => {
        setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName)); // Toggle logic
    };

    const getHomePath = (role) => {
        if (role === 'freelancer') return '/freelancer-home';
        if (role === 'business') return '/business-home';
        return '/home';
    };

    // const handleDropdownClose = () => {
    //     setIsDropdownClosed(true); // Set state when dropdown is closed
    //     setOpenDropdown(null); // Close dropdown
    // };

    const [searchQuery, setSearchQuery] = useState("");

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        console.log("Searching for:", searchQuery);
        // Implement search functionality here
    };

    const handleMailboxClick = () => {
        // Optimistically clear unread badge
        setUnreadCount(0);

        // Navigate to inbox
        navigate("/home/mailbox");
    };

    const handleDeleteAccount = async () => {
        setIsSettingsOpen(false);
        if (window.confirm('Are you sure you want to delete your account? This action cannot be undone.')) {
            try {
                setLoading(true);
                setError(null);

                await deleteAccount(); // ✅ use centralized apiClient
                setSuccess(true);
                setLoading(false);

                toast.success('Account deleted successfully!');
                logout(); // clear tokens and redirect
                navigate("/"); // redirect to home
            } catch (error) {
                setLoading(false);
                setError(error.response?.data?.detail || 'An error occurred while deleting your account.');
            }
        }
    };
    

    if (hidden) return null;

    return (
        <header>
            <div className="logoandslogan">
                <button onClick={toggleNav} className="menu-button">
                    <i className="fa-solid fa-bars"></i>
                </button>

                <Link to={getHomePath(role)} className="logo-link">
                    <ServSpaceLogo width={460} height={120} />
                </Link>
            </div>

            <div className="buttons-container">
                {accessToken && (
                    <>
                        {(role === "freelancer" || role === "business") && (
                            <button
                                className="header-button mailbox-button"
                                onClick={handleMailboxClick}
                                title="Mailbox"
                            >
                                <Mailbox color="white" />

                                {unreadCount > 0 && (
                                    <span className="mailbox-badge">
                                        {unreadCount}
                                    </span>
                                )}
                            </button>
                        )}
                        <DropdownMenu
                            isOpen={openDropdown === "menu"}
                            toggleDropdown={() => handleDropdownToggle("menu")}
                            openSettings={() => setIsSettingsOpen(true)}
                        />
                    </>
                )}

                {/* Login + Sign Up buttons only on public routes */}
                {!accessToken && (
                    <div className="auth-buttons">
                        <button className="login-button" onClick={() => navigate("/login")}>
                            Log In
                        </button>
                        <button className="signup-button" onClick={() => navigate("/signup")}>
                            Sign Up
                        </button>
                    </div>
                )}
            </div>

            <SettingsModal
                settingsOpen={isSettingsOpen}
                onClose={() => setIsSettingsOpen(false)}
                isDarkMode={isDarkMode}
                toggleTheme={toggleTheme}
                handleDeleteAccount={handleDeleteAccount}
                profile={profile}
            />
        </header>
    );
}

export default Header;